"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const react_i18next_1 = require("react-i18next");
const Body = ({ measurement }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [measurement && ((0, jsx_runtime_1.jsx)(typography_1.H4, { children: `${t("measurement.overview.createdAt")} ${measurement.createdAt}` }, void 0)), measurement && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { src: measurement.photoFront }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("measurement.overview.characteristics.weight") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("measurement.overview.characteristics.height") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: measurement.weight }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: measurement.height }, void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { src: measurement.photoSide }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("measurement.overview.characteristics.shoulders") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("measurement.overview.characteristics.breast") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: measurement.shoulders }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: measurement.breast }, void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("img", { src: measurement.photoBack }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("measurement.overview.characteristics.waist") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("measurement.overview.characteristics.hips") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: measurement.waist }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: measurement.legs }, void 0)] }, void 0)] }, void 0)] }, void 0))] }, void 0));
};
exports.Body = Body;
const Wrapper = styled_components_1.default.div `
  &:empty {
    display: none;
  }

  & > h4 {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }

  & > div {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: ${({ theme }) => theme.spacings.m};

    img {
      height: auto;
      margin-bottom: ${({ theme }) => theme.spacings.m};
      object-fit: cover;
      width: 100%;
    }

    img + div {
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      p {
        margin-bottom: 0;
      }

      p,
      h4 {
        line-height: 1.5rem;
      }

      h4 {
        margin-bottom: ${({ theme }) => theme.spacings.xxs};
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    p,
    h4 {
      display: none;
    }

    & > div img {
      margin-bottom: 0;
    }
  }
`;
//# sourceMappingURL=Body.js.map